

/* profile-menu-dialog.component.ts */
import { Component, Inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from "../../component/layout/element/button.component";
import { LOCATION_LABEL } from "../../../../globalTypes/configs";
import { Store } from '@ngrx/store';
import { AccountActions, accountFeature } from '../../store/account.store';
import { Logger } from '../../helper/logger';
import { lastValueFrom, take } from 'rxjs';
import { httpsCallable, HttpsCallableResult } from 'firebase/functions';
import { Functions } from '@angular/fire/functions';
import { User } from '../../../../globalTypes/user.types';
import { FocusedFormComponent } from '../../component/wrapper/focused-form.component';
import { AuthService } from '../../services/auth.service';
import { MatCheckbox } from "@angular/material/checkbox";
import { MatSnackBar } from "@angular/material/snack-bar";
const log = new Logger("InviteDialog");
``
export interface InviteDialogData {
  user: {
    email: string;
    displayName: string;
  },
  location: {
    id: string;
    segment: {
      id: string;
    }
    name: string;
    profileImage?: {
      url: string;
    }
  },
  inviteToYourLocation?: boolean;
  message?: string;
}
  

@Component({
  selector: 'msh-invite-dialog',
  standalone: true,
  imports: [MatIconModule, FormsModule, MatDialogModule, MatButtonModule, RouterModule, ButtonComponent, MatCheckbox],
  template: `
<div class=" z-10 relative">
  <mat-icon class="absolute top-4 right-4" [mat-dialog-close]="false">close</mat-icon>
</div>
<div class="dialog-container relative m-4 mt-12 overflow-auto  ">
    <div class=" mb-3 text-copy font-bold">Invite {{data.user.displayName}} to join {{data.location.name}}</div>  
    <input
      type="email"
      placeholder="Email"
      [(ngModel)]="data.user.email"
      name="email"
      required
    />
    <textarea 
      [(ngModel)]="data.message"
      name="message"
      class="border"
      placeholder="Message (optional)"
      rows="10"
    ></textarea>
    <mat-checkbox [(ngModel)]="data.inviteToYourLocation" name="inviteToYourLocation">Invite {{data.user.displayName}} to join your {{LOCATION_LABEL}} ({{data.location.name}})</mat-checkbox>
</div>
<div class="bg-navy-50 gap-4 py-4 px-6 flex justify-end">
    <msh-button [cta]="'Invite'" (onClick)="inviteUser()" [disabled]="disabled || !data.user || !data.user.email" ></msh-button>
</div>

  `,
  styles: ``
})
export class InviteDialogComponent {
  disabled = false;
  LOCATION_LABEL = LOCATION_LABEL;
  constructor(
    private functions: Functions,
    private store: Store,
    private snackbar: MatSnackBar,
    private authService: AuthService,
    public dialogRef: MatDialogRef<InviteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InviteDialogData,
  ){
  }

  async inviteUser(){
    console.log({email: this.data.user.email, location: this.data.location});
    if(this.data.user.email && this.data.location) {
      this.disabled = true;
      try {
        await this.authService.saveInvite({
          email: this.data.user.email, 
          segmentId: this.data.location.segment.id, 
          locationId: this.data.inviteToYourLocation ? this.data.location.id : '', 
          locationName: this.data.location.name, 
          message: this.data.message, 
          locationImageURL: this.data.location.profileImage?.url})
      } catch(e){
        log.error("Error inviting user", e);
        this.snackbar.open("Error inviting user", "Close", {duration: 3000});
        return ;
      }
      this.data.user.email = '';
      this.data.message = '';  
      this.disabled = false;
    }

    this.dialogRef.close(true)
  }

  onSubmit(event: any){
    console.log({submit: "invite user", event, email: this.data.user.email, message: this.data.message, location: this.data.location})
  }

}
